import React from "react";
import "./TypeaheadClearButtonComponent.scss";

interface TypeaheadClearButtonProps {
  id: string;
  onMouseDown: (event: React.MouseEvent<HTMLButtonElement>) => void;
  onKeyDown: (event: React.KeyboardEvent<HTMLButtonElement>) => void;
  handleOnBlur: (event: React.FocusEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
}

const TypeaheadClearButton = ({
  id,
  onMouseDown,
  disabled,
  onKeyDown,
  handleOnBlur,
}: TypeaheadClearButtonProps) => (
  <button
    id={id}
    type="button"
    onMouseDown={onMouseDown}
    onKeyDown={onKeyDown}
    onBlur={handleOnBlur}
    className={`sid-input-clear-button ${disabled ? "sid-input-clear-button--disabled" : ""}`}
    aria-label="clear text"
    aria-disabled={disabled}
    tabIndex={0}
  >
    <svg
      viewBox="0 0 24 24"
      preserveAspectRatio="none"
      width={28}
      fill="none"
      stroke={disabled ? "#B6B6B6" : "#5A5A5A"}
      strokeWidth="1.1"
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
    </svg>
  </button>
);

export const TypeaheadClearButtonComponent = TypeaheadClearButton;
